export interface Vehicle {
  id: string
  name: string
  plateNumber: string
  vehicleCode?: string
  customName?: string
  operationalIdentifier?: string
  iconKey?: string
  identifierType?: string // 'Plate Number', 'Asset SN', 'Booking Ref', 'Lock Code'
  driver?: Driver
  location: Location
  status: VehicleStatus
  speed: number
  heading: number
  lastUpdate: Date
  fuel?: number
  odometer?: number
  engineHours?: number
  temperature?: number
  batteryLevel?: number
  signalStrength?: number
  trackingStatus?: 'LIVE' | 'STALE' | 'OFFLINE' | 'NOT_TRACKED'
  currentSpeed?: number | null
  vehicleSource?: 'ASSET' | 'CONTAINER'
  baliseCodes?: string[]
  baliseBattery?: number | null
  baliseCount?: number
  // Enhanced fields from database
  deviceType?: string
  firmwareVersion?: string
  assignmentStatus?: string
  // Enhanced context information
  containerInfo?: {
    id?: number
    name?: string
    type?: string
    bookingReference?: string
    equipmentReference?: string
    owner?: string
    destination?: string
    origin?: string
    status?: string
    customerName?: string
    customerCode?: string
    customerType?: string
    customerPriority?: string
  }
  assetInfo?: {
    id?: number
    code?: string
    type?: string
    brand?: string
    model?: string
    licensePlate?: string
    status?: string
    customerName?: string
    customerCode?: string
    customerType?: string
    customerPriority?: string
  }
  customerInfo?: {
    id?: number
    name?: string
    code?: string
    source?: 'container' | 'asset' | null
  }
  transport?: VehicleTransport | null
}

export interface VehicleTransport {
  corridorId?: string | null
  corridorName?: string | null
  departure?: string | null
  destination?: string | null
  progress?: number | null // 0-100 along the route
  source?: string | null // MANUAL | CMA_API
}

export interface Driver {
  id: string
  name: string
  licenseNumber?: string
  phone?: string
  email?: string
}

export interface Location {
  latitude: number
  longitude: number
  address?: string
  city?: string
  country?: string
  accuracy?: number
}

export enum VehicleStatus {
  MOVING = 'moving',
  STOPPED = 'stopped',
  IDLE = 'idle',
  OFFLINE = 'offline',
  MAINTENANCE = 'maintenance'
}

export interface VehicleHistory {
  vehicleId: string
  timestamp: Date
  location: Location
  speed: number
  heading: number
  event?: string
}

export interface Geofence {
  id: string
  name: string
  type: 'circle' | 'polygon'
  coordinates: number[][]
  radius?: number
  color?: string
}

export interface Alert {
  id: string
  vehicleId: string
  type: AlertType
  message: string
  severity: 'low' | 'medium' | 'high' | 'critical'
  timestamp: Date
  acknowledged: boolean
}

export enum AlertType {
  SPEED_VIOLATION = 'speed_violation',
  GEOFENCE_EXIT = 'geofence_exit',
  GEOFENCE_ENTER = 'geofence_enter',
  ENGINE_FAULT = 'engine_fault',
  LOW_FUEL = 'low_fuel',
  MAINTENANCE_DUE = 'maintenance_due',
  PANIC_BUTTON = 'panic_button',
  UNAUTHORIZED_USE = 'unauthorized_use'
}

export interface TimelineData {
  timestamp: Date
  speed: number
  status: VehicleStatus
  location: Location
  event?: string
}

export interface MapBounds {
  north: number
  south: number
  east: number
  west: number
}

export interface FilterOptions {
  status?: VehicleStatus[]
  drivers?: string[]
  dateRange?: {
    start: Date
    end: Date
  }
  speedRange?: {
    min: number
    max: number
  }
}
